import type { ConsoleRoute } from '../index';
import { BrandsPage } from './BrandsPage';
import { CatalogHomePage } from './CatalogHome';
import { ProductBuilderPage } from './ProductBuilder';
import { PrizeDetailPage, PrizesListPage, ProductsListPage } from './PrizesPages';
import { SponsorFormPage, SponsorsListPage } from './SponsorsPage';

const CATALOG = ['prizes.manage', 'sponsors.manage', 'brands.manage'] as const;

export const catalogRoutes: ConsoleRoute[] = [
  {
    path: 'catalog',
    handle: { permission: CATALOG, title: 'Sponsors & prizes' },
    element: <CatalogHomePage />,
  },
  {
    path: 'catalog/products',
    handle: { permission: 'prizes.manage', title: 'Products' },
    element: <ProductsListPage />,
  },
  {
    path: 'catalog/products/new',
    handle: { permission: 'prizes.manage', title: 'New product' },
    element: <ProductBuilderPage />,
  },
  {
    path: 'catalog/products/:id',
    handle: { permission: 'prizes.manage', title: 'Product' },
    element: <ProductBuilderPage />,
  },
  {
    path: 'catalog/prizes',
    handle: { permission: 'prizes.manage', title: 'Prizes' },
    element: <PrizesListPage />,
  },
  {
    path: 'catalog/prizes/:id',
    handle: { permission: 'prizes.manage', title: 'Prize' },
    element: <PrizeDetailPage />,
  },
  {
    path: 'catalog/brands',
    handle: { permission: 'brands.manage', title: 'Approved brands' },
    element: <BrandsPage />,
  },
  {
    path: 'catalog/sponsors',
    handle: { permission: 'sponsors.manage', title: 'Sponsors' },
    element: <SponsorsListPage />,
  },
  {
    path: 'catalog/sponsors/new',
    handle: { permission: 'sponsors.manage', title: 'New sponsor' },
    element: <SponsorFormPage />,
  },
  {
    path: 'catalog/sponsors/:id',
    handle: { permission: 'sponsors.manage', title: 'Sponsor' },
    element: <SponsorFormPage />,
  },
];
